import { render, staticRenderFns } from "./portfolioPageContent.vue?vue&type=template&id=c287a0bc&scoped=true"
import script from "./portfolioPageContent.vue?vue&type=script&lang=js"
export * from "./portfolioPageContent.vue?vue&type=script&lang=js"
import style0 from "./portfolioPageContent.vue?vue&type=style&index=0&id=c287a0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c287a0bc",
  null
  
)

export default component.exports